import React, { useState } from "react";
import { CarouselItem } from "./CarouselItem";
export const Carousel = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const items = [
    {
      title: "Μαρία Μιχαηλίδου, Παιδαγωγικό 2020",
      description:
        "«Επέλεξα το φροντιστήριο Άνοδος και είμαι πολύ ευχαριστημένη με την ποιότητα εκπαίδευσης που μου παρείχε και στις 3 τάξεις του λυκείου. Οι καθηγητές ήταν πραγματικά εξαιρετικοί με πλούσια μεταδοτικότητα και οργάνωση. Επιπλέον μας παρείχαν εκπαιδευτικό υλικό το οποίο αποδείχτηκε πολύ σημαντικό εργαλείο για την επιτυχία των στόχων μας. Πέρα από την τυπική σχέση εκπαιδευτικού και μαθητή όμως αυτά τα χρόνια μας υποστήριζαν και μας ενθάρρυναν με κάθε πιθανό τρόπο. Χτίσαμε μια ιδιαίτερη σχέση αγάπης και κατανόησης, πήραμε πολλά πράγματα από αυτούς τους ανθρώπους και τους είμαι πραγματικά ευγνώμων.»",
      icon: require("./Media/Graduation.svg"),
    },
    {
      title: "Σωτηρία Σώμου, Αγωγής και φροντίδας στη πρώιμη Παιδική Ηλικία 2020",
      description:
        "«Επέλεξα το φροντιστήριο Άνοδος και νιώθω πολύ ικανοποιημένη από αυτή την επιλογή μου, καθώς όλοι οι εκπαιδευτικοί ήταν πάντα εκεί στην προσπάθεια να καλυφθούν όλα τα μαθησιακά κενά που υπήρχαν από προηγούμενα χρόνια, με ψυχολογική στήριξη και υποστηρικτικό  τρόπο, με απώτερο σκοπό να εκπληρώσω τον στόχο μου.»",
      icon: require("./Media/Graduation.svg"),
    },
    {
      title: "Σαμπουγκασίδου Ρένα, Μαθηματικό 2020",
      description:
        "«Το φροντιστήριο Άνοδος  για μένα ήταν η ιδανική επιλογή. Με έφτασε στην ζωή σου πανεπιστημίου μέσα από πνευματική και ψυχική καλλιέργεια. Πρόκειται για ένα περιβάλλον με αλληλοκατανόηση, ομαδικό και μεθοδικό πνεύμα που με στήριξε καθ’ όλη την πορεία.»",
      icon: require("./Media/Graduation.svg"),
    },
    {
      title: "Γιώργος Αβράμης, Πληροφορική 2020",
      description:
        "«Ξεκίνησα με το φροντιστήριο Άνοδος από την δευτέρα λυκείου και συνέχισα την επόμενη χρονιά για τα μαθήματα των πανελλαδικών. Η επίδοση μου δεν θα ήταν πουθενά κοντά σε αυτήν που είχα στις εξετάσεις αν δεν πήγαινα στο φροντιστήριο, καθώς εκεί είχα δίπλα μου καθηγητές που ήταν πολύ ενθαρρυντικοί και γεμάτοι εμπειρία που βοηθούσε ψυχολογικά σε θέματα όπως στην διαχείριση του άγχους αλλά και στον τρόπο σκέψης γενικότερα. Γενικά ήταν ένα περιβάλλον που ήταν γεμάτο χαρά και ενέργεια αλλά και σοβαρότητα εκεί που έπρεπε.»",
      icon: require("./Media/Graduation.svg"),
    },
    {
      title: "Ευγενία Δήμου, Φυσικής 2018",
      description:
        "«Το φροντιστήριο Άνοδος στάθηκε δίπλα μου και με την πολυετή εμπειρία του στις πανελλαδικές εξετάσεις με βοήθησε να χαράξω το μονοπάτι της επιτυχίας μου σε αυτές. Οι καθηγητές ήταν πάντα παρόντες όταν τους χρειαζόμουν και δούλευαν ως μια ενεργή ομάδα, δημιουργώντας ένα οικείο κλίμα το οποίο με βοήθησε να περάσω στην σχολή που επιθυμούσα.»",
      icon: require("./Media/Graduation.svg"),
    },
    {
      title: "Μαρία Μιχαλέρη, Μηχανικών Πληροφορικής 2023",
      description:
        "«Στο φροντιστήριο Άνοδος από τη πρώτη στιγμή το κλίμα είναι πολύ όμορφο και ζεστό, κάνει τους μαθητές να νιώσουν οικειότητα. Οι καθηγητές είναι πολύ άνετοι, με διάθεση να βοηθήσουν και να λύσουν κάθε απορία. Σε βοηθάνε πάρα πολύ με τη μεθοδευμένη -και πολύ καλά οργανωμένη- διδακτική ύλη. Με τον καιρό οι σχέσεις που αναπτύσσονται ανάμεσά τους είναι πολύ όμορφες και αυτό είναι που μένει!!»",
      icon: require("./Media/Graduation.svg"),
    },
    {
      title: "Μόκκα Αποστολία, Πολιτικών Μηχανικών 2023",
      description:
        "«Η εμπειρία μου τρία χρόνια που βρισκόμουν στην Άνοδο, ήταν γεμάτη ευχάριστες στιγμές! Το κλίμα είναι φιλικό, οι καθηγητές έχουν άριστη γνώση του αντικειμένου τους, το οποίο αγαπούν και αυτό βγαίνει προς τα έξω μέσα από το μάθημα τους! Στη διάρκεια αυτών των χρόνων, εκτός από το διδακτικό κομμάτι, οι καθηγητές ήταν πάντα δίπλα μου για ζητήματα που με απασχολούσαν, πρόθυμοι να με βοηθήσουν και να με συμβουλεύσουν. Το φροντιστήριο, έκανε τη διαδρομή μου προς το πανεπιστήμιο πολύ ευχάριστη.»",
      icon: require("./Media/Graduation.svg"),
    },
    {
      title: "Στέλλα Φραντζούλη, Οργάνωσης & Διοίκησης Επιχειρήσεων 2023",
      description:
        "«Ήμουν στο φροντιστήριο Άνοδος για 3 συνεχόμενα χρόνια και έχω μείνει υπερευχαριστημένη. Το κλίμα είναι πολύ ζεστό, φιλικό και οι καθηγητές-τριες που δουλεύουν εκεί άψογοι στην δουλειά τους. Δεν αφήνουν κανένα περιθώριο για κενά πάνω στη μάθημα τους και ότι ζητήσεις θα στο εξηγήσουν όσες φορές χρειάζεται. Στο μάθημα τους προσπαθούν να δώσουν κίνητρο σε κάθε μαθητή να κάνει το καλύτερο που μπορεί. Είναι άξιοι άνθρωποι, ταλαντούχοι και θα βάλουν τα δυνατά τους για να σε βοηθήσουν να πετύχεις το στόχο σου.»",
      icon: require("./Media/Graduation.svg"),
    },
    {
      title: "Κωνσταντίνα Χατζηνικολάου, Κινηματογράφου 2023",
      description:
        "«Στο φροντιστήριο Άνοδος έμαθα πολλά χρήσιμα πράγματα από αξιόλογους ανθρώπους που με στήριξαν και με βοήθησαν να ανταπεξέλθω στις εξετάσεις. Οι καθηγητές εκεί δεν νοιάζονται μόνο για τον βαθμό σου και το μάθημα αλλά και για εσένα ως προσωπικότητα και σε βοηθούν μέχρι και όταν δεν έχεις πειθαρχεία να πετύχεις τους στόχους σου.  Νιώθω ευγνωμοσύνη και τους ευχαριστώ μέσα απ' την καρδιά μου .Παράλληλα τα vibes που επικρατούν στην Άνοδο είναι πάντα θετικά καθώς όλοι είναι χαμογελαστοί και κάνουν τρελό χιούμορ!!»",
      icon: require("./Media/Graduation.svg"),
    },
    {
      title: "Γιάννης Μπαναμπάκης, Λογιστικής & Χρηματοοικονομικής 2023",
      description:
        "«Πανελλήνιες 2023: Θανάσης, Νικολέτα, Βαΐα, Ειρήνη όχι απλά ήταν οι καθηγητές μου, αλλά μια δεύτερη οικογένεια, για έναν ολόκληρο χρόνο. Ήταν εκεί από την πρώτη στιγμή. Μαζί και στα εύκολα και στα δύσκολα. Σε πολλούς από εμάς τα φροντιστήρια έμειναν χαραγμένα ως ατέλειωτες ώρες μαθημάτων αλλά σε εμένα το φροντιστήριο Άνοδος έμεινε ως ένα όμορφο ταξίδι προς την επιτυχία !!»",
      icon: require("./Media/Graduation.svg"),
    },
    {
      title: "Καλτζίδου Ματίνα, Επιστήμης Υπολογιστών 2023",
      description:
        "«Το φροντιστήριο Άνοδος ξεχώρισε για τις όμορφες στιγμές που μας πρόσφερε, καθώς και για τον καθοριστικό του ρόλου στο να καταφέρουμε να κατακτήσουμε τους στόχους μας.»",
      icon: require("./Media/Graduation.svg"),
    },
    {
      title: "Ανώνυμος, Εμπορικό Ναυτικό 2023",
      description:
        "«Το φροντιστήριο άνοδος σου δίνει ευκαιρίες που δεν μπορείς να το δεις μόνος σου, το προσωπικό του έμπειρο έμπιστο και καθοδηγητικό. Όσο και δύσκολη να ήταν η 3η λυκείου υπήρχε ψυχολογική υποστήριξη και βοήθεια. Μαθητής που δεν είχε καμία σχέση με τα βιβλία μπόρεσε να καταφέρει τον στόχο του, όποιος και αν ήταν αυτός, υπήρχε πίστη σε μένα και εγώ σε αυτούς. Φυσικά αν δεν προσπαθούσα και εγώ δεν θα γινόταν τίποτα αλλά όταν έχεις κατάλληλους ανθρώπους να σου ανοίγουν τον δρόμο και να σου δίνουν ώθηση σου βγαίνει και εσένα να κάνεις μια προσπάθεια πρώτα για τον εαυτό σου και μετά για αυτούς. Για αυτό και έχω τεράστια εκτίμηση σε όλους από το φροντιστήριο Άνοδος έναν έναν ξεχωριστά, περάσαμε σιγουρα καλά, είχαμε και τις δύσκολες στιγμές μας αλλά μέσα από αυτό δυναμώνουμε. Ευχαριστώ για όλα!»",
      icon: require("./Media/Graduation.svg"),
    },
    {
      title: "Παπαδόπουλος Αλέξανδρος, Αγροτικής Ανάπτυξης 2023",
      description:
        "«Το φροντιστήριο Άνοδος είναι ένα εξαιρετικό φροντιστήριο, διότι έχει καθηγητές με πλήρη γνωστικές και διδακτικές ικανότητες και ταυτόχρονα ξέρουν να επικοινωνούν και με τους μαθητές. Επίσης είναι ένας ευχάριστος χώρος γεγονός που σε διευκολύνει πάρα πολύ στο να κυλήσει ο χρόνος σε μια δύσκολη μέρα.»",
      icon: require("./Media/Graduation.svg"),
    },
  ];
  const updateIndex = (newIndex) => {
    if (newIndex < 0) {
      newIndex = 0;
    } else if (newIndex >= items.length) {
      newIndex = items.length - 1;
    }

    setActiveIndex(newIndex);
  };
  return (
    <div className="carousel">
      <div
        className="inner"
        style={{ transform: `translate(-${activeIndex * 100}%)`
     }}
      >
        {items.map((item) => {
          return <CarouselItem item={item} width={"100%"} />;
        })}
      </div>

      <div className="carousel-buttons">
        <button
          className="button-arrow"
          onClick={() => {
            updateIndex(activeIndex - 1);
          }}
        >
          <span class="material-symbols-outlined">arrow_back_ios</span>{" "}
        </button>
        <div className="indicators">
          {items.map((item, index) => {
            return (
              <button
                className="indicator-buttons"
                onClick={() => {
                  updateIndex(index);
                }}
              >
                <span
                  className={`material-symbols-outlined ${
                    index === activeIndex
                      ? "indicator-symbol-active"
                      : "indicator-symbol"
                  }`}
                >
                  radio_button_checked
                </span>
              </button>
            );
          })}
        </div>
        <button
          className="button-arrow"
          onClick={() => {
            updateIndex(activeIndex + 1);
          }}
        >
          <span class="material-symbols-outlined">arrow_forward_ios</span>
        </button>
      </div>
    </div>
  );
};